<template>
  <div>validate UAE Pass</div>
  <NotificationGroup>
    <Notification v-slot="{ notifications }">
      <!-- Here you have typed `notifications` -->
    </Notification>
  </NotificationGroup>
</template>

<script setup>
import { computed, onMounted, onBeforeUnmount, ref } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useRoute, useRouter } from 'vue-router'
import { notify } from 'notiwind'

const route = useRoute()
const router = useRouter()

const authStore = useAuthStore()

const st = ref()

const isValidResponse = computed(() => {
  const queryKeys = Object.keys(route.query)
  const hasCode = queryKeys.includes('code')
  const hasState = queryKeys.includes('state')

  return hasCode && hasState
})

onMounted(async () => {
  if (route.query.error) {
    notify(
      {
        group: 'error',
        title: route.query.error
      },
      6000
    )
    st.value = setTimeout(() => {
      window.clearTimeout(st)
      router.push('/')
    }, 4000)
    return
  }
  if (isValidResponse.value) {
    authStore.$patch((state) => {
      state.accessCode = route.query.code
      state.state = route.query.state
    })
    await authStore.getAccessToken(route.query.code)
    await authStore.getUAEPassUserInfo()
  }
})
onBeforeUnmount(() => {
  window.clearTimeout(st.value)
})
</script>

<style lang="scss" scoped></style>
